(async () => {
    const { Core } = await importModule('Core');
    const { cartProvider } = await importModule('Utils');
    const { Swiper } = await importModule('Swiper');
    
    const ATTR_INITIAL_VARIANT_ID = 'variant-id'; 
    const ATTR_SWIPER_FLAG = 'swiper-required';

    customElements.define('product-popup-gallery', class extends Core {

        elements = {
            variantSelect: '[data-variant-select]',
            swiper: '[data-swiper]',
            cartButton: '[data-add-to-cart]'
        }
        
        render() {
            this._initSwiper();
            this._handleVariantChange();
            // this._handleAddToCart();
        }

        // disconnect() {
        //     this.$cartButton?.removeEventListener(
        //         'click',
        //         this._addToCart.bind(this)    
        //     )
        // }

        _initSwiper() {
            if (this.swiperRequired) {
                this.swiper = new Swiper(this.$swiper, { allowTouchMove: false });
            }
        }

        _handleVariantChange() {
            this.swiper && this.$variantSelect?.addEventListener(
                'change', 
                this._onOptionChange.bind(this)
            )
        }
        
        _handleAddToCart() {
            this.$cartButton?.addEventListener(
                'click',
                this._addToCart.bind(this)    
            )
        }

        _onOptionChange({ target }) {
            this.variantId = target.value;
            this._slideImage() 
        }

        _slideImage() {
            this.targetSlideId !== -1 && this.swiper?.slideTo(this.targetSlideId);
        }

        _addToCart() {
            console.log('adding to card');
            cartProvider(this)
                .add([{
                    id: this.variantId || this.initialVariantId, 
                    quantity: 1
                }])
        }

        get swiperRequired() {
            return this.hasAttribute(ATTR_SWIPER_FLAG);
        }

        get targetSlideId() {
            return this.swiper.slides.findIndex(slide => slide.dataset.variantId === this.variantId)
        }

        get initialVariantId() {
            return this.getAttribute(ATTR_INITIAL_VARIANT_ID);
        }
    })
})();